import { render, staticRenderFns } from "./import-legal-attestation.vue?vue&type=template&id=0e60651a&"
import script from "./import-legal-attestation.vue?vue&type=script&lang=js&"
export * from "./import-legal-attestation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports